import React, { useState } from "react";
import { COLORS } from "../../Constants/AppColors.js";
import { useTranslation } from "react-i18next";
import "../../Translation/i18n";
import i18n from "i18next";

function OurVisionPage() {
  const { t } = useTranslation();

  const [innerWidthState, setInnerWidthState] = useState(window.innerWidth);
  const [innerHeightState, setInnerHeightState] = useState(window.innerHeight);
  const [directionState, setDirectionState] = useState("ltr");

  React.useEffect(() => {
    if (i18n.language.includes("en")) {
      setDirectionState("ltr");
    } else {
      setDirectionState("ltr");
    }

    function handleResize() {
      console.log("resized to: ", window.innerWidth, "x", window.innerHeight);
      setInnerWidthState(window.innerWidth);
      setInnerHeightState(window.innerHeight);
    }

    window.addEventListener("resize", handleResize);

    console.log("i18n.locale: " + i18n.language);
  });

  return (
    <div
      dir={directionState}
      style={{
        backgroundColor: "#F7F8F9",
        width: innerWidthState + "px",
        height: innerHeightState - 100 + "px",
        backgroundSize: "cover",
        display: "flex",
      }}
    >
      <img
        src={require("../../assets/our_vision_image.png")}
        alt="logo"
        style={{
          marginTop: 10,
          marginBottom: 10,
          marginLeft: -(innerWidthState / 10),
        }}
      />
      <div
        style={{
          width: innerWidthState / 3 + "px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          marginLeft: i18n.language.includes("en") ? 30 : 0,
          marginRight: i18n.language.includes("ar") ? 30 : 0,
        }}
      >
        <label
          style={{
            color: COLORS.PageTitleFirstColor,
            fontSize: 35,
            textAlign: i18n.language.includes("en") ? "left" : "right",
            fontFamily: i18n.language.includes("en")
              ? "CI-Font-Title"
              : "CI-Font-Title-ar",
          }}
        >
          {t("our_vision_pt1")}{" "}
          <label
            style={{
              color: COLORS.PageTitleSecondColor,
              fontSize: 35,
              textAlign: i18n.language.includes("en") ? "left" : "right",
              fontFamily: i18n.language.includes("en")
                ? "CI-Font-Title"
                : "CI-Font-Title-ar",
            }}
          >
            {t("our_vision_pt2")}
          </label>
        </label>
        <label
          style={{
            color: COLORS.TextColor,
            marginTop: 15,
            fontSize: 15,
            textAlign: i18n.language.includes("en") ? "left" : "right",
            wordWrap: "break-word",
            whiteSpace: "pre-wrap",
            width: innerWidthState / 3 + "px",
            fontFamily: i18n.language.includes("en")
              ? "CI-Font-Body-Text"
              : "CI-Font-Body-Text-ar",
          }}
        >
          {t("our_vision_text")}
        </label>
      </div>
    </div>
  );
}

export default OurVisionPage;
